import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { TRACKING_ID } from "../core/site";

/**
 * Starts GA4 once and keeps admin routes out of it. GA sends every page_view
 * itself: one on load, and one per SPA navigation through the property's
 * enhanced measurement (history events). Sending our own as well counted each
 * page twice. Does nothing without a tracking id; `ga` is injectable for tests.
 *
 * @param {{ trackingId?: string, ga?: { initialize: Function } }} [deps]
 */
export function usePageViews({ trackingId = TRACKING_ID, ga = ReactGA } = {}) {
	const { pathname } = useLocation();
	const isAdmin = pathname.startsWith("/admin");

	// GA's own opt-out flag; set before initialize so an admin landing page is
	// never counted, and kept current so admin navigations aren't either.
	useEffect(() => {
		if (trackingId) window[`ga-disable-${trackingId}`] = isAdmin;
	}, [trackingId, isAdmin]);

	useEffect(() => {
		if (trackingId) ga.initialize(trackingId);
	}, [trackingId, ga]);
}
